export default "__VITE_ASSET__9PyMYjnr__"